import React from "react";
import "./Footer.css";
import mailIcon from "../assets/e.svg";
import phoneIcon from "../assets/phone.png";
import addressIcon from "../assets/address.png";
import logo from "../assets/logo.png";

const Footer = () => {
  return (
    <footer className="footer-container">
      <div className="footer-content">
        <div className="footer-left">
          <div className="logo">
            <img src={logo} alt="RUNG DO Logo" className="logo-img" />
          </div>
        </div>

        <div className="footer-center">
          <ul className="footer-links">
            <li>
              <a href="/">Home</a>
            </li>
            <li>
              <a href="/e-store">E-Store</a>
            </li>
            <li>
              <a href="/paint-calculator">Paint Calculator</a>
            </li>
            <li>
              <a href="/about-us">About Us</a>
            </li>
            {/* <li>
              <a href="/creator">Creator</a>
            </li> */}
          </ul>
        </div>

        <div className="footer-right">
          <p className="contact-info">
            Karachi, Pakistan <img src={addressIcon} alt="Address Icon" className="icon3" />
          </p>
          <p className="contact-info">
            +92 314 7864360 <img src={phoneIcon} alt="Phone Icon" className="icon2" />
          </p>
          <p className="contact-info">
            info@rungdo.com
            <img src={mailIcon} alt="Mail Icon" className="mail-icon" />
          </p>
        </div>
      </div>

      <div className="footer-bottom">
        {/* <p className="creator-credit">
          Powered by <a href="/creator">Sohail Asghar</a>
        </p> */}
        <p>&copy; 2026 Rung Do Media. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
